<script setup>
import { computed } from 'vue'
import printJS from 'print-js'
defineEmits(['loaded'])
const props = defineProps(['link', 'scale'])
const scaleCSS = computed(() => `scale(${props.scale ?? 1})`)

defineExpose({
  print: () => {
    printJS(props.link, 'image')
  },
})
</script>
<template>
  <div
    class="vstack gap-3 pt-3"
    ref="pages-canva"
  >
    <div
      class="pdf-view border align-self-center shadow"
      ref="page-el"
    >
      <img
        :src="link"
        @load="$emit('loaded')"
      />
    </div>
  </div>
</template>
<style scoped>
.vstack {
  min-height: 100%;
  min-width: 100%;
  width: fit-content;
}
.pdf-view {
  transform: v-bind('scaleCSS');
  transform-origin: left top;
}
</style>
